import { Flex, View, tokens } from '@sapphire-react/core';
import { ReactNode, useEffect, useRef } from 'react';
import { useScroll } from '../hooks/useScroll';

type Props = {
  children: ReactNode;
  focus?: boolean;
  isHidden?: boolean;
  withPadding?: boolean;
  withSeparator?: boolean;
  borderRadius?: string | number;
  withBorder?: boolean;
  showLeftBorderRadius?: boolean;
  backgroundColor?: string;
};

export function ResultLayout({
  children,
  focus,
  isHidden,
  withPadding = true,
  withSeparator = true,
  borderRadius = tokens.size.radiusSm.value,
  withBorder = true,
  backgroundColor = tokens.color.backgroundNeutralSubtle.value,
  showLeftBorderRadius = true,
}: Props) {
  const scroll = useScroll({ scrollTo: 'start' });
  const divRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (focus) {
      scroll(divRef.current);
    }
  }, [scroll, focus]);

  if(isHidden) return null;

  return (
    <Flex width={'100%'} ref={divRef} height={'100%'}>
      {withSeparator && (
        <View
          backgroundColor={backgroundColor}
          paddingTop={{ base: 24, md: 32 }}
          paddingBottom={{ base: 24, md: 32 }}
        >
          <View
            isHidden={{ base: true, xs: false }}
            width={1}
            height={'100%'}
            backgroundColor={tokens.color.borderSecondary.value}
          />
        </View>
      )}

      <View
        paddingLeft={withPadding ? { base: 12, sm: 16, md: 32 } : 0}
        paddingRight={withPadding ? { base: 12, sm: 16, md: 32 } : 0}
        paddingTop={withPadding ? { base: 24, md: 32 } : 0}
        paddingBottom={withPadding ? { base: 24, md: 32, sm: 0 } : 0}
        flexDirection={'column'}
        width={'100%'}
        height={'100%'}
        backgroundColor={backgroundColor}
        borderRadius={borderRadius}
        borderBottomRightRadius={borderRadius}
        borderTopRightRadius={borderRadius}
        borderBottomLeftRadius={showLeftBorderRadius ? borderRadius : 0}
        borderTopLeftRadius={showLeftBorderRadius ? borderRadius : 0}
        data-test-id={'results'}
        borderLeft={
          withBorder
            ? {
                base: `1px solid ${tokens.color.borderSecondary.value}`,
                sm: 'none',
              }
            : 'none'
        }
      >
        {children}
      </View>
    </Flex>
  );
}
